import Swal from "sweetalert2";

const toastMixin = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2200,
  timerProgressBar: false,
  customClass: {
    popup: "cms-swal-toast company-forms-swal-toast",
    title: "cms-swal-toast__title company-forms-swal-toast-title",
    htmlContainer: "cms-swal-toast__text company-forms-swal-toast-text",
    icon: "cms-swal-toast__icon company-forms-swal-toast-icon",
  },
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

/** Small top-right status messages (success, info, etc.). */
export function companyFormToast(options) {
  return toastMixin.fire({
    icon: "success",
    ...options,
  });
}

export function companyFormToastError(title, text) {
  return toastMixin.fire({
    icon: "error",
    title,
    text,
    timer: 3000,
  });
}

export function companyFormToastWarning(title, text = "") {
  return toastMixin.fire({
    icon: "warning",
    title,
    text: text || undefined,
    timer: 2800,
  });
}

/** Compact centered confirm / prompt dialogs. */
export function companyFormConfirm(options) {
  return Swal.fire({
    confirmButtonColor: "#007BFF",
    customClass: {
      popup: "company-forms-swal-dialog",
      title: "company-forms-swal-dialog-title",
      htmlContainer: "company-forms-swal-dialog-text",
      input: "company-forms-swal-dialog-input",
      confirmButton: "company-forms-swal-btn company-forms-swal-btn--primary",
      cancelButton: "company-forms-swal-btn company-forms-swal-btn--cancel",
    },
    ...options,
  });
}
